// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Location: React.FC = () => {
    return <svg width="23px" height="32px" viewBox="0 0 23 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-381.000000, -290.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(302.000000, 60.000000)">
                    <path d="M11.0655738,0 C4.96401639,0 0,4.96401639 0,11.0655738 C0,13.1270902 0.571045082,15.1389344 1.65178279,16.8843443 L10.4356967,31.0394877 C10.6039549,31.3106557 10.9003893,31.4754098 11.2192008,31.4754098 C11.2216598,31.4754098 11.2240574,31.4754098 11.2265164,31.4754098 C11.5480943,31.4728893 11.8451434,31.3030328 12.0103279,31.0271311 L20.5703484,16.7348361 C21.5914549,15.0263115 22.1311475,13.0659221 22.1311475,11.0655738 C22.1311475,4.96401639 17.1671311,0 11.0655738,0 Z M18.9876639,15.7879918 L11.2052459,28.7819262 L3.21928279,15.9126639 C2.31971311,14.459877 1.83196721,12.7838115 1.83196721,11.0655738 C1.83196721,5.98094262 5.98094262,1.83196721 11.0655738,1.83196721 C16.1502049,1.83196721 20.2930328,5.98094262 20.2930328,11.0655738 C20.2930328,12.7328484 19.8374385,14.3660656 18.9876639,15.7879918 Z"></path>
                    <path d="M11.0655738,5.53278689 C8.01479508,5.53278689 5.53278689,8.01479508 5.53278689,11.0655738 C5.53278689,14.0968648 7.97440574,16.5983607 11.0655738,16.5983607 C14.1948566,16.5983607 16.5983607,14.0635451 16.5983607,11.0655738 C16.5983607,8.01479508 14.1163525,5.53278689 11.0655738,5.53278689 Z M11.0655738,14.7663934 C9.02108607,14.7663934 7.3647541,13.1045287 7.3647541,11.0655738 C7.3647541,9.03172131 9.03172131,7.3647541 11.0655738,7.3647541 C13.0994262,7.3647541 14.7602459,9.03172131 14.7602459,11.0655738 C14.7602459,13.0747746 13.142459,14.7663934 11.0655738,14.7663934 Z"></path>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Location);
